export const fetchGraphUser = async (accessToken) => {
  try {
    const response = await fetch("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${accessToken}`, 
        Accept: "application/json",
      },
    });

    if (!response.ok) throw new Error("Failed to fetch user info");

    const userData = await response.json();
    let photoUrl = "/default-avatar.jpg";

    try {
      const photoResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (photoResponse.ok) {
        const photoBlob = await photoResponse.blob();
        photoUrl = URL.createObjectURL(photoBlob);
      }
    } catch (photoError) {
      console.warn("Profile photo fetch failed, using default avatar.");
    }

    userData.photo = photoUrl;

    sessionStorage.setItem("userData", JSON.stringify(userData));
    return userData;
  } catch (error) {
    console.error("Graph API error:", error);
    throw error;
  }
};